export default {
    // selectedLanguage: 'en',
    selectedLanguage: 'en',
    editable: false,
    avaibableLanguages: ['en'],
    translationKeys:{}
};